import { render, staticRenderFns } from "./SecondTitle.vue?vue&type=template&id=1af71004&scoped=true&"
import script from "./SecondTitle.vue?vue&type=script&lang=js&"
export * from "./SecondTitle.vue?vue&type=script&lang=js&"
import style0 from "./SecondTitle.vue?vue&type=style&index=0&id=1af71004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af71004",
  null
  
)

export default component.exports